import { HelpCircle } from 'lucide-react'
import { Tooltip } from './Tooltip'

interface HelpIconProps {
  content: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  size?: 'sm' | 'md'
  className?: string
}

export function HelpIcon({
  content,
  position = 'top',
  size = 'sm',
  className = ''
}: HelpIconProps) {
  const sizeStyles = {
    sm: 'h-3.5 w-3.5',
    md: 'h-4 w-4',
  }

  return (
    <Tooltip content={content} position={position}>
      <HelpCircle
        className={`
          ${sizeStyles[size]}
          text-slate-400 hover:text-slate-600
          dark:text-slate-500 dark:hover:text-slate-300
          cursor-help transition-colors
          ${className}
        `}
      />
    </Tooltip>
  )
}
